import React from "react";
import { Link } from "react-router-dom";
import PageShell from "../components/layout/PageShell";
import useScrollReveal from "../hooks/useScrollReveal";

export default function Concours() {
  useScrollReveal();

  return (
    <PageShell
      title="Concours & Admissions"
      subtitle="Conditions, pièces à fournir, calendrier et étapes du processus de sélection."
    >
      {/* Hero Banner */}
      <section className="ema-reveal" style={{
        background: 'linear-gradient(135deg, #0B2C5F 0%, #1e3a6e 100%)',
        borderRadius: '20px',
        padding: '40px',
        marginBottom: '36px',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{ position: 'absolute', top: '-40px', right: '-40px', width: '180px', height: '180px', borderRadius: '50%', background: 'rgba(212,175,55,0.1)' }} />
        <div style={{ position: 'absolute', bottom: '-20px', left: '30%', width: '100px', height: '100px', borderRadius: '50%', background: 'rgba(255,255,255,0.03)' }} />

        <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '16px' }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          <span style={{ color: '#D4AF37', fontSize: '13px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '2px' }}>Promotion 9, bientôt ouvert</span>
        </div>
        <h2 style={{ color: '#fff', fontSize: '24px', fontWeight: 800, marginBottom: '12px' }}>Le concours d'admission est fermé</h2>
        <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: '15px', lineHeight: 1.6, marginBottom: '24px', maxWidth: '600px' }}>
          Les informations (dates, conditions, documents) sont publi&eacute;es dans les communiqu&eacute;s officiels. Consultez cette page pour les mises &agrave; jour.
        </p>

        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          <Link to="/register" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: '#D4AF37', color: '#071b3b', padding: '12px 24px', borderRadius: '100px', fontWeight: 700, fontSize: '14px', textDecoration: 'none' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>
            Candidater maintenant
          </Link>
          <Link to="/login" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: 'rgba(255,255,255,0.1)', color: '#fff', padding: '12px 24px', borderRadius: '100px', fontWeight: 600, fontSize: '14px', textDecoration: 'none', border: '1px solid rgba(255,255,255,0.2)' }}>
            Espace candidat
          </Link>
          <Link to="/announcements" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: 'rgba(255,255,255,0.7)', padding: '12px 24px', borderRadius: '100px', fontWeight: 600, fontSize: '14px', textDecoration: 'none' }}>
            Communiqués →
          </Link>
        </div>
      </section>

      {/* Conditions */}
      <section className="ema-reveal" style={{ marginBottom: '36px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div style={{ width: '4px', height: '32px', background: '#D4AF37', borderRadius: '4px' }} />
          <h2 style={{ fontSize: '20px', fontWeight: 800, color: '#0B2C5F' }}>Conditions d'éligibilité</h2>
        </div>
        <p style={{ fontSize: '15px', color: '#6B7280', lineHeight: 1.6, marginBottom: '20px' }}>
          Les candidats doivent satisfaire aux critères administratifs et académiques définis par l'École de la Magistrature.
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '14px' }}>
          {[
            { icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0B2C5F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v18"/><path d="M3 7h18"/><path d="M6 7l-3 5h6"/><path d="M18 7l3 5h-6"/></svg>, text: "Respect des conditions légales du concours" },
            { icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0B2C5F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>, text: "Licence en Droit minimum (Bac+4)" },
            { icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0B2C5F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>, text: "Dossier complet dans les délais" },
            { icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0B2C5F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>, text: "Casier judiciaire conforme aux exigences" }
          ].map((item, i) => (
            <div key={i} style={{
              display: 'flex', alignItems: 'center', gap: '14px', padding: '16px 20px',
              background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.03)', transition: 'all 0.2s'
            }}
              onMouseOver={(e) => { e.currentTarget.style.borderColor = '#0B2C5F'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
              onMouseOut={(e) => { e.currentTarget.style.borderColor = '#e5e7eb'; e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              {item.icon}
              <span style={{ fontSize: '14px', fontWeight: 600, color: '#374151' }}>{item.text}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Pièces */}
      <section className="ema-reveal" style={{ marginBottom: '36px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div style={{ width: '4px', height: '32px', background: '#0B2C5F', borderRadius: '4px' }} />
          <h2 style={{ fontSize: '20px', fontWeight: 800, color: '#0B2C5F' }}>Pièces à fournir</h2>
        </div>
        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 16px rgba(0,0,0,0.04)' }}>
          {[
            { label: "Pièce d'identité valide (NIF ou CIN)", req: true },
            { label: "Diplôme de Licence en Droit (copie certifiée)", req: true },
            { label: "Relevés de notes universitaires", req: true },
            { label: "2 photos d'identité récentes", req: true },
            { label: "Formulaire d'inscription rempli", req: true },
            { label: "Extrait de casier judiciaire (moins de 3 mois)", req: true },
            { label: "Certificat médical", req: false },
            { label: "Autres documents précisés dans le communiqué", req: false }
          ].map((doc, i, arr) => (
            <div key={i} style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px',
              padding: '14px 24px',
              borderBottom: i < arr.length - 1 ? '1px solid #f3f4f6' : 'none',
              transition: 'background 0.15s'
            }}
              onMouseOver={(e) => e.currentTarget.style.background = '#f9fafb'}
              onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={doc.req ? '#0B2C5F' : '#9CA3AF'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                <span style={{ fontSize: '14px', fontWeight: 600, color: '#374151' }}>{doc.label}</span>
              </div>
              <span style={{
                fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px',
                padding: '3px 10px', borderRadius: '100px',
                background: doc.req ? 'rgba(11,44,95,0.08)' : 'rgba(156,163,175,0.1)',
                color: doc.req ? '#0B2C5F' : '#9CA3AF'
              }}>
                {doc.req ? 'Obligatoire' : 'Si applicable'}
              </span>
            </div>
          ))}
        </div>
      </section>

      {/* Calendrier */}
      <section className="ema-reveal" style={{ marginBottom: '36px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div style={{ width: '4px', height: '32px', background: '#D4AF37', borderRadius: '4px' }} />
          <h2 style={{ fontSize: '20px', fontWeight: 800, color: '#0B2C5F' }}>Calendrier du concours</h2>
        </div>
        <div style={{ position: 'relative', paddingLeft: '32px' }}>
          <div style={{ position: 'absolute', left: '11px', top: '12px', bottom: '12px', width: '2px', background: 'linear-gradient(to bottom, #0B2C5F, #D4AF37)', borderRadius: '2px' }} />
          {[
            { step: 'Ouverture des inscriptions', date: '', status: 'done' },
            { step: "Clôture des inscriptions", date: "", status: 'done' },
            { step: "Publication liste d'admissibilité", date: "", status: 'active' },
            { step: "Épreuves écrites", date: '', status: 'upcoming' },
            { step: 'Grand oral', date: '', status: 'upcoming' },
            { step: "Publication des résultats", date: '', status: 'upcoming' }
          ].map((item, i) => (
            <div key={i} style={{ position: 'relative', paddingBottom: '20px' }}>
              <div style={{
                position: 'absolute', left: '-27px', top: '6px', width: '14px', height: '14px', borderRadius: '50%',
                background: item.status === 'done' ? '#10b981' : item.status === 'active' ? '#D4AF37' : '#e5e7eb',
                border: '3px solid #fff',
                boxShadow: item.status === 'active' ? '0 0 0 3px rgba(212,175,55,0.3)' : '0 0 0 2px rgba(0,0,0,0.05)'
              }} />
              <div style={{
                background: item.status === 'active' ? '#fffbeb' : '#fff',
                border: `1px solid ${item.status === 'active' ? 'rgba(212,175,55,0.3)' : '#e5e7eb'}`,
                borderRadius: '12px', padding: '16px 20px', marginLeft: '8px'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontWeight: 600, color: '#1f2937', fontSize: '14px' }}>{item.step}</span>
                  <span style={{ fontSize: '12px', fontWeight: 700, color: item.status === 'done' ? '#10b981' : item.status === 'active' ? '#D4AF37' : '#9CA3AF' }}>{item.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Processus */}
      <section className="ema-reveal" style={{ marginBottom: '36px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div style={{ width: '4px', height: '32px', background: '#0B2C5F', borderRadius: '4px' }} />
          <h2 style={{ fontSize: '20px', fontWeight: 800, color: '#0B2C5F' }}>Processus de candidature</h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
          {[
            { n: '1', title: "Créer un compte", text: "Inscrivez-vous sur la plateforme en ligne.", icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>, to: '/register' },
            { n: '2', title: "Déposer les documents", text: "Téléversez les pièces demandées.", icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>, to: '/dashboard' },
            { n: '3', title: "Vérification", text: "Votre dossier est examiné par l'administration.", icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>, to: '/announcements' },
            { n: '4', title: "Épreuves", text: "Convocations publiées selon le calendrier officiel.", icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>, to: '/announcements' }
          ].map((step, i) => (
            <Link key={i} to={step.to} style={{
              textDecoration: 'none', background: '#fff', border: '1px solid #e5e7eb',
              borderRadius: '16px', padding: '28px 20px', textAlign: 'center',
              transition: 'all 0.3s ease', position: 'relative', overflow: 'hidden'
            }}
              onMouseOver={(e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 12px 32px rgba(11,44,95,0.1)'; e.currentTarget.style.borderColor = '#0B2C5F'; }}
              onMouseOut={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.borderColor = '#e5e7eb'; }}
            >
              <div style={{ position: 'absolute', top: '12px', right: '12px', fontSize: '11px', fontWeight: 800, color: '#D4AF37', background: 'rgba(212,175,55,0.1)', width: '24px', height: '24px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {step.n}
              </div>
              <div style={{ color: '#0B2C5F', marginBottom: '14px', display: 'flex', justifyContent: 'center' }}>{step.icon}</div>
              <h3 style={{ fontSize: '15px', fontWeight: 700, color: '#0B2C5F', marginBottom: '8px' }}>{step.title}</h3>
              <p style={{ fontSize: '13px', color: '#6B7280', lineHeight: 1.5 }}>{step.text}</p>
            </Link>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="ema-reveal" style={{
        background: 'linear-gradient(135deg, #D4AF37 0%, #f4d03f 100%)',
        borderRadius: '20px', padding: '40px',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '20px'
      }}>
        <div>
          <h2 style={{ fontSize: '22px', fontWeight: 800, color: '#071b3b', margin: '0 0 8px' }}>Prêt à commencer ?</h2>
          <p style={{ fontSize: '15px', color: 'rgba(7,27,59,0.7)', margin: 0 }}>Créez votre compte candidat et déposez votre dossier en ligne.</p>
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          <Link to="/register" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: '#0B2C5F', color: '#fff', padding: '14px 28px', borderRadius: '100px', fontWeight: 700, fontSize: '14px', textDecoration: 'none' }}>
            Créer un compte
          </Link>
          <Link to="/login" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: 'rgba(7,27,59,0.1)', color: '#071b3b', padding: '14px 28px', borderRadius: '100px', fontWeight: 600, fontSize: '14px', textDecoration: 'none' }}>
            Se connecter
          </Link>
        </div>
      </section>
    </PageShell>
  );
}
